import { render } from "./PrivacyConsent.vue?vue&type=template&id=ccd5ab2a&scoped=true"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js"

import "./PrivacyConsent.vue?vue&type=style&index=0&id=ccd5ab2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd5ab2a"]])

export default __exports__